import React from 'react';
import _ from 'lodash';

import {
  List,
  Datagrid,
  BooleanField,
  DateField,
  ImageField,
  TextField,
  CardActions,
  ShowButton,
  CreateButton,
  ExportButton,
  FunctionField,
  Filter,
  TextInput,
  SelectInput,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

import { offeringCategory, externalOfferSelection } from '../../helpers/mappings';

import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';

const styles = {
  image: {
    margin: '0.25rem',
    maxHeight: '4rem',
    maxWidth: '4rem',
  },
};

const SquareImageField = withStyles(styles)(props => (
  <ImageField className={props.classes.image} {...props} />
));

const UserCardActions = ({
  basePath,
  data,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions>
      { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
        <CreateButton basePath={basePath} record={data} /> : undefined
      }
      <ExportButton resource="offerings" />
    </CardActions>
  );
};

const OfferFilters = props => (
  <Filter {...props}>
    <TextInput label="Name" source="_LIKE_name" alwaysOn />
    <SelectInput
      label="Category"
      source="category"
      choices={_.values(offeringCategory)
                     .map(item => ({
                         id: item.value,
                         name: item.label,
                       }))}
      alwaysOn
      allowEmpty
      defaultValue={false}
    />
    <SelectInput
      label="Offer source"
      source="isExternalOffer"
      choices={_.values(externalOfferSelection)
            .map(item => ({
              id: item.value ? 1 : 0,
              name: item.label,
            }))}
      alwaysOn
      allowEmpty
      defaultValue={false}
    />
  </Filter>
);

export default props => (
  <List
    {...props}
    sort={{ field: 'name', order: 'ASC' }}
    title="Offers"
    bulkActionButtons={false}
    actions={<UserCardActions />}
    filters={<OfferFilters />}
  >
    <Datagrid>
      <SquareImageField source="logoUrl" sortable={false} label="Logo" />
      <TextField source="name" />
      <TextField label="Folio Id" source="folioId" />
      <FunctionField
        label="Category"
        render={record => `${_.values(offeringCategory).find(item => item.value === record.category).label}`}
      />
      <BooleanField source="visibleToEndUsers" />
      <FunctionField
        label="Offer source"
        render={record => `${_.values(externalOfferSelection).find(item => item.value === record.isExternalOffer).label}`}
      />
      <TextField source="status" />
      <DateField source="startDate" />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/Offer/List.js